<script>
  import Router from 'svelte-spa-router'
  import { routes } from './routes'
  import Header from './components/Header.svelte'
  import Meta from './components/Meta.svelte'
  import Footer from './components/Footer.svelte'
  import Timeline from './routes/Timeline.svelte'
  export let title = 'The Outlier - July Protests'
  export let description =
    'For a week in July 2021 protests and looting spread trhoughout South Africa, and much of it was spurred on by social media.'
  export let url = 'https://julyprotests.theoutlier.co.za/'
  export let keywords = 'protests, looting, july'
  export let image =
    'https://theoutlier.co.za/wp-content/uploads/2021/12/riot.png'
</script>

<main>
  <Header />
  <Router {routes} />
  <!-- <Footer /> -->
</main>
